import React, { useEffect, useState, useRef } from "react";
import { useHistory, Link } from "react-router-dom";
import { logout, useAuthDispatch, useAuthState } from "../../Context";
import { NewVisit } from "../../Pages/NewVisit";
import HeaderLogo from "../HeaderLogo/HeaderLogo";
import WelcomePageBrainImage from "../../Images/WelcomePageImages/Welcome-Svg.svg";
import WelcomePageStroopImage from "../../Images/WelcomePageImages/Welcome-Stroop.svg";
import WelcomePageNumberImage from "../../Images/WelcomePageImages/Welcome-Number.svg";
import WelcomePageTohokuUniversityLetters from "../../Images/WelcomePageImages/Welcome-Tohoku-University.svg";
import WelcomePageCogSmartLogo from "../../Images/WelcomePageImages/Welcome-CogSma-Logo.svg";
import "../WelcomePage/welcome-page.css";

export default function WelcomePage() {
  let testing_allowed = useRef(true);
  const [isMegalos, setIsMegalos] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    //parts[0] should be the subdomain if there is any
    // If there is a subdomain and it is "megalos", set isMegalos to true.
    if (parts.length > 2 && parts[0] === "megalos") {
      setIsMegalos(true);
      console.log("Subdomain is megalos");
      console.log("Subdomain: ", parts[0]);
      // if(parts.length > 2) {
      //   console.log("Subdomain: ", parts[0])
    } else {
      console.log("No subdomain in use");
    }
  }, []);

  return (
    <>
      <HeaderLogo />
      <div className="head welcome-text-button-results-container">
        <div className="welcome-text-container">
          <h1>
            {isMegalos ? (
              <>
                リボーンズスクール
                <br />
                脳の健康3分チェック
              </>
            ) : (
              <>
                <div className="cogtest-mini-title">CogTest mini</div>
                脳への影響3分チェック
              </>
            )}
          </h1>
        </div>
      </div>

      <div className="text-box">
        <p className="centered-text">
          <b>ストレス・生活習慣・加齢</b>などは、
          実は見えないところで、あなたの脳のパフォーマンスへ、影響を与えています。
        </p>
        <img
          src={WelcomePageBrainImage}
          alt="welcome-brain"
          className="welcome-brain-img"
        />
      </div>

      <p
        className="centered-text centered-text--nudge"
        style={{ marginBottom: "24px" }}
      >
        30歳以上の方、<u>本来のパフォーマンスが発揮できていないかも</u>
        しれません。
        <wbr />
        <br />
        まずは、簡単に、チェックしてみませんか。
      </p>

      <div className="section-banner">
        <h1>テストは２問</h1>
      </div>

      <div className="test-preview-container">
        <div>
          <img
            src={WelcomePageStroopImage}
            alt="welcome-stroop-test"
            width="100%"
          />
        </div>
        <div>
          <img
            src={WelcomePageNumberImage}
            alt="welcome-number-test"
            width="100%"
          />
        </div>
      </div>

      {/* Render the "今すぐ開始" button only if not on the megalos subdomain */}
      {!isMegalos && (
        <Link
          to="/practice/unregistered-stroop-test-b"
          className="continue-button"
        >
          <h2>はじめる</h2>
        </Link>
      )}

      {isMegalos && (
        <div className="text-box">
          <p>
            フィットネスクラブで、ランニングやスタジオプログラム、水泳などの息が弾む運動を行い、しかも筋トレもすると、海馬の神経が生まれ変わり、記憶力もアップすることが分かっています。
            <br />
            リボーンズスクールではこのためのサポートを行っています。
            <br />
            <br />
            「脳の健康3分チェック」で注意力・処理機能を測ってみましょう！
          </p>
        </div>
      )}

      <h3 className="centered-text">
        サインアップ・ログインは<Link to="/login">こちら</Link>
      </h3>

      {/* <div className="text-box">
    <p>
    {isMegalos ? (
        <>
          フィットネスクラブで、ランニングやスタジオプログラム、水泳などの息が弾む運動を行い、しかも筋トレもすると、海馬の神経が生まれ変わり、記憶力もアップすることが分かっています。
          <br />
          リボーンズスクールではこのためのサポートを行っています。
          <br />
          <br />
          「脳の健康3分チェック」で注意力・処理機能を測ってみましょう！
        </>
      ) : (
        "会員登録せずに下のボタンより進むことで、点数のみを確認することもできます。"
      )}
    </p>
  </div> */}

      <div className="footer-disclaimer">
        ※本テストは独自のテスト項目であり、科学的根拠に基づいた診断結果を提供するものではございません。
      </div>

      <div className="footer-note-container">
        <div className="footer-logo-container">
          <img
            src={WelcomePageTohokuUniversityLetters}
            alt="tohoku"
            className="footer-logo"
          />
          <img
            src={WelcomePageCogSmartLogo}
            alt="cogsma"
            className="footer-logo"
          />
        </div>
      </div>

      {/* <div className="historic-results-box">
        <div className="historic-results-header">
          <p>会員登録すると・・・<br></br>全国の同年代・性別と比較した偏差値がわかる！</p>
        </div> */}
      {/* 総合点 */}
      {/* <div className="head welcome-text-button-results-container">
          <div className="welcome-text-container"><h1>テストの結果例</h1></div>
        </div>
        <div className="score__grid">
          <span className="item1">総合点</span>
          <span className="score"><b>86</b><small>/100</small></span><span className="item3">点</span>
        </div> */}
      {/* eslint-disable-next-line */}
      {/* <div className="deviation-container" style={{width:60+'%'}}>
          <p className="deviation-text">偏差値 {60}</p>
        </div> */}
      {/* テスト１ */}
      {/* <div className="score__grid">
          <span className="item1">注意力テスト</span>
          <span className="score"><b>44</b><small>/100</small></span><span className="item3">点</span>
        </div> */}
      {/* eslint-disable-next-line */}
      {/* <div className="deviation-container" style={{width:40+'%'}}>
          <p className="deviation-text">偏差値 {56}</p>
        </div> */}
      {/* テスト2 */}
      {/* <div className="score__grid">
          <span className="item1">処理機能テスト</span>
          <span className="score"><b>42</b><small>/100</small></span><span className="item3">点</span>
        </div> */}
      {/* eslint-disable-next-line */}
      {/* <div className="deviation-container" style={{width:40+'%'}}>
          <p className="deviation-text">偏差値 {46}</p>
        </div>
      </div> */}

      {/* <Link to='/signup' className="continue-button">
          <h2>会員登録して開始</h2>
        </Link>

        <h4>会員登録済みの方は<Link to='/login'>ログイン</Link></h4> */}
    </>
  );
}
